import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

interface WPPage {
  id: number;
  title: { rendered: string };
  content: { rendered: string };
  date: string;
}

const PageSingle: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [page, setPage] = useState<WPPage | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;

    const fetchPage = async () => {
      try {
        const res = await axios.get<WPPage[]>(
          `https://blog.thecryptotutor.com/wp-json/wp/v2/pages?slug=${slug}`
        );
        setPage(res.data[0]);
      } catch (err) {
        console.error('Error loading page:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) return <div className="text-center py-16">Loading...</div>;
  if (!page) return <div className="text-center py-16">Page not found</div>;

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      <main className="max-w-4xl mx-auto px-4 py-8">
        <article className="bg-white rounded-lg shadow-sm p-8">
          <h1
            className="text-3xl font-bold mb-6 text-gray-900"
            dangerouslySetInnerHTML={{ __html: page.title.rendered }}
          />
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: page.content.rendered }}
          />
        </article>
      </main>
    </div>
  );
};

export default PageSingle;
